module.exports = __webpack_public_path__ + "static/media/app.a6bc48f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app.jpg
// module id = 2009
// module chunks = 2